import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import Rating from '@mui/material/Rating';
import TutorRating from 'components/TutorRating';
import { useState } from 'react';

function RatingUpdateModal({ show, closeModal, data = {} }) {
  const [updateRating, setUpdateRating] = useState(false);

  return (
    <AppModal open={show} closeModal={closeModal} size="sm">
      <AppModalHeader>Rating info</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text">
          <Rating
            name="read-only"
            value={data?.currentRating}
            readOnly
            precision={0.5}
            size="large"
            className="mx-4"
            title={'You have received' + data?.currentRating}
          />
        </p>

        <div className="d-flex align-items-center justify-content-center my-4">
          <p>
            The rating given for this question was <strong>{data?.currentRating}</strong> out of{' '}
            <strong>5</strong>.
          </p>
        </div>
        <div
          className={`d-flex align-items-center justify-content-center my-4 ${
            updateRating ? 'flex-column' : ''
          }`}
        >
          {!updateRating && (
            <>
              <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
                KEEP THIS RATING
              </AppButton>
              <AppButton
                variantClass="btn-plane p--tint mx-4"
                onClick={() => {
                  setUpdateRating(true);
                }}
              >
                UPDATE RATING
              </AppButton>
            </>
          )}
          {updateRating && (
            <>
              <p>You can update the rating by clicking the desired stars down below</p>

              <TutorRating
                ratingValue={data?.currentRating}
                apiArgs={{ ...(data?.apiArgs || {}) }}
                fns={{ successCb: closeModal }}
              />

              {/* <AppButton variantClass="btn btn-danger mx-4" onClick={closeModal}>
                CLOSE
              </AppButton> */}
            </>
          )}
        </div>

        {updateRating && (
          <div className="app-l-modal-btn-block mb-4 d-flex justify-content-center">
            <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
              CLOSE
            </AppButton>
          </div>
        )}
      </AppModalBody>
      <AppModalFooter></AppModalFooter>
    </AppModal>
  );
}

export default RatingUpdateModal;
